import { createAction } from "redux-actions";

export const setLoading = createAction("SET_LOADING");
export const setLoaded = createAction("SET_LOADED");
export const setDirection = createAction("SET_DIRECTION");
export const setLanguage = createAction("SET_LANGUAGE");
